const { SAAS_AUTH } = require("../variable");

const config = () => {
  return {
    license: SAAS_AUTH.FUSION_CHART_LICENSE,
  };
};

module.exports = config;
